import Config from 'modules/config';

import apiFetch from '../../api-fetch';
import Toast from '../../toast';
import { setAuthToken } from '..';

const signIn = async (values) => {
  console.log('sign in called...');
  const config = {
    url: 'MobileAccount/Login',
    method: 'POST',
    body: values,
  };

  let result;
  try {
    result = await apiFetch(config);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      Toast.error('Invalid login information');
      return false;
    }

    Toast.error('Something went wrong! Try again soon.');
    return false;
  } finally {
    // formik.setSubmitting(false);
  }

  // Set the login results about the user into the store

  if (Config.IS_TRAINER_APP) {
    if (Object.values(result.roles).includes('Client')) {
      Toast.error(
        'You are logging in with a client login. This will not end the way you think.',
      );
      return null;
    }
  }

  if (Config.IS_CLIENT_APP) {
    if (Object.values(result.roles).includes('Trainer')) {
      Toast.error(
        'You are logging in with a trainer login. This will not end the way you think.',
      );
      return null;
    }
  }

  await setAuthToken(result.token);

  return true;
};

export default signIn;
